module.exports = "<div ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 1\"><categories-input-filter sh-ctrl=$ctrl.shCtrl></categories-input-filter></div><div ng-show=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 2\"><categories-slider-filter sh-ctrl=$ctrl.shCtrl></categories-slider-filter></div><div ng-if=\"$ctrl.ngAuthSettings.site.config.data.categories.menuType === 3\"><categories-sliding-filter sh-ctrl=$ctrl.shCtrl></categories-sliding-filter></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-filter.view.html
 ** module id = 450
 ** module chunks = 8
 **/